import script from "./MyTicketInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./MyTicketInfo.vue?vue&type=script&setup=true&lang=js"

import "./MyTicketInfo.vue?vue&type=style&index=0&id=14b7a63e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14b7a63e"]])

export default __exports__